import React, { Component } from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import routes from "./routes";

import history from "./_helpers/history";
import Router from "react-router-dom/es/Router";
import Switch from "react-bootstrap/cjs/Switch";
import {Route} from "react-router-dom";


class App extends Component {
  render() {
    return (
        <Router history={history} >
          <Switch className ="ml-0 p-0 w-100 h-100">
            {routes.map((route, index) => (
                <Route
                    key={index}
                    exact={route.exact}
                    path={route.path}
                    component={route.layout(route.component)}
                />
            ))}
          </Switch>
        </Router>
    );
  }
}

export default App;
